/******/
(() => {
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == 'drawer') {
        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();
          return false;
        });

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        // Single source of truth: only drawer removes the line
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);
        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();
        return false;
      });

      // Cart Drawer Slider (theme default)
      setTimeout(function(){
        $('.ajax-cart__slider').flickity({
          lazyLoad: 2,
          draggable: true,
          initialIndex: 0,
          wrapAround: false,
          cellAlign: 'left',
          pageDots: false,
          arrowShape: arrowShape,
          adaptiveHeight: true,
          prevNextButtons: true
        });
      },1000);

      $('.button--add-to-cart').on('click', function() {
        setTimeout(function(){
          $('.ajax-cart__slider').toggleClass('is-expanded').flickity('resize');
        },2000);
      });
    },

    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');
      $el.hover(function() {
        if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function() {
        $el.removeClass('show-mini-cart');
      });
    },

    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },

    toggleMiniCart: function() {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');
      $el.attr('href', '#');
      $el.off('touchstart').on('touchstart', function (e) {
        if (e.target.closest('[data-ajax-cart-mini_cart]')) return;
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();
        $el.toggleClass('show-mini-cart');
      });
    },

    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
      setTimeout(() => { $('html').addClass('overflow-hidden'); }, 300);
    },

    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
      $('html').removeClass('overflow-hidden');
    },

    removeFromCart: function (lineID, callback) {
      const _this = this;
      window.__mg_suppress_refresh = true;
      document.dispatchEvent(new CustomEvent('trunkpass:checkout:lock'));

      const finish = function(){
        window.__mg_suppress_refresh = false;
        if (typeof callback === 'function') callback();
      };

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function(){ Shopify.theme.jsAjaxCart.updateView(); },
        complete: function(){ 
          $.ajax({
            dataType: 'html',
            url: '/cart',
            success: function (html) {
              const $newCartForm = $(html).find('.cart__form');
              if ($newCartForm.length && $('.cart__form').length) $('.cart__form').replaceWith($newCartForm);
            },
            complete: finish
          });
        }
      }).fail(function(){ finish(); });
    },

    initializeAjaxCart: function () {
      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, 'ajax'
      )
      .done(({ html, options }) => {
        $('[data-ajax-cart-content]').html(html.content);
        if (Shopify.theme.currencyConverter) Shopify.theme.currencyConverter.convertCurrencies();
      });
    },

    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();
      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, 'ajax'
      )
      .done(({ html }) => {
        $('.mobile-header [data-ajax-cart-content]').html(html.content);
      });
    },

    addToCart: function ($addToCartForm) {
      const $btn = $addToCartForm.find('.button--add-to-cart');
      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($btn[0].hasAttribute('data-options-unselected')) {
        const msg = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;
        $('.warning').remove();
        $addToCartForm.addClass('shopify-product-form--unselected-error')
          .find('.cart-warning').html(msg);
        $btn.removeAttr('disabled').removeClass('disabled');
        $btn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $btn.find('span:not(.icon)').text($btn.data('label')).removeClass('zoomOut').addClass('zoomIn');
        return;
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          document.dispatchEvent(new CustomEvent('trunkpass:checkout:lock'));
          $btn.attr('disabled','disabled').addClass('disabled');
          $btn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function () {
          let $el = $('[data-ajax-cart-trigger]');
          $btn.find('.checkmark').addClass('checkmark-active');

          function addedToCart() {
            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }
            $el.addClass('show-mini-cart');
            $btn.find('span').removeClass('fadeInDown');
          }

          setTimeout(function () {
            $btn.removeAttr('disabled').removeClass('disabled');
            $btn.find('.checkmark').removeClass('checkmark-active');
            $btn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
            $btn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: 'html',
              url: '/cart',
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);
              }
            });
          }
        },
        error: function (xhr) {
          let response = eval('(' + xhr.responseText + ')');
          response = (response.message) ? response.message : response.description;
          const msg = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;
          $('.warning').remove();
          $addToCartForm.find('.cart-warning').html(msg);
          $btn.removeAttr('disabled').removeClass('disabled');
          $btn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
          $btn.find('span:not(.icon)').text($btn.data('label')).removeClass('zoomOut').addClass('zoomIn');
        }
      });
    },

    updateView: function () {
      console.log("[log-cart-update-view-called]")
      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, 'ajax'
      )
      .done(({ html, options }) => {
        if (options.item_count > 0) {
          const itemList    = $(html.content).find('.ajax-cart__list');
          const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
          const total_price = options.total_price;

          $('.ajax-cart__list').replaceWith(itemList);
          $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
          $('.ajax-cart__empty-cart-message').addClass('is-hidden');
          $('.ajax-cart__form, .ajax-form-wrap, .counts').removeClass('is-hidden');
          $('[data-ajax-cart-trigger]').addClass('has-cart-count');
          $('[data-bind="itemCount"]').text(options.item_count);

          // optional free-shipping indicator (as-is)
          if ($('[data-fs-threshold]').length) {
            let $parent = $('[data-fs-threshold]');
            let $remainingWrapper = $parent.find('.fs-indicator__remaining');
            let $successWrapper   = $parent.find('.fs-indicator__success');
            let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
            if (fs_threshold >= total_price) {
              let fs_remaining = fs_threshold - total_price;
              let fs_remaining_percent = total_price / fs_threshold * 100;
              $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%');
              $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining));
              $remainingWrapper.removeClass('is-hidden');
              $successWrapper.addClass('is-hidden');
            } else {
              $remainingWrapper.addClass('is-hidden');
              $successWrapper.addClass('is-hidden');
            }
          }

        } else {
          $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
          $('.ajax-cart__form, .ajax-form-wrap, .counts').addClass('is-hidden');
          $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
          $('[data-bind="itemCount"]').text('0');
          $('.ajax-cart__list').empty();
          $('.ajax-cart__details-wrapper').addClass('is-hidden');
        }

        if (Shopify.theme.currencyConverter) Shopify.theme.currencyConverter.convertCurrencies();

        // Signals
        try { $(document).trigger('cart:updated'); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      });

      Shopify.theme.jsAjaxCart.syncTrunkPassFees(function(isUnlock){
        if(isUnlock){
          document.dispatchEvent(new CustomEvent('trunkpass:checkout:unlock'));
        }
      });
    },

    syncTrunkPassFees: function (done) {
      console.log("[log-cart-sync-pass-called]")
      var cfg = document.querySelector('[data-trunk-pass-config]');
      if (!cfg) {
        if (done) done(true);
        return;
      }

      var feeVariantId = cfg.getAttribute('data-fee-variant-id');
      var trunkTag = cfg.getAttribute('data-trunk-tag') || 'Maison Trunk Pass subscriber';
      if (!feeVariantId) {
        if (done) done(true);
        return;
      }

      var customerTags = (window.__customer_tags || []);
      if (typeof customerTags === 'string') {
        customerTags = customerTags.split(',').map(function (t) { return t.trim(); });
      }

      var isTrunk = customerTags.indexOf(trunkTag) !== -1;

      if(!isTrunk){
        if (done) done(true);
        return
      }

      $.getJSON('/cart.js', function (cart) {
        var rentalQty = 0;
        var feeLine = null;

        cart.items.forEach(function (item, idx) {
          var isRental = item.properties && item.properties._cycle;
          if (isRental) {
            rentalQty += item.quantity;
          }
          var isFee = (item.properties && item.properties._trunk_fee === 'true') || (String(item.variant_id) === String(feeVariantId));
          if (isFee) {
            feeLine = {
              line: idx + 1,
              quantity: item.quantity
            };
          }
        });

        if (rentalQty === 0) {
          if (feeLine) {
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                line: feeLine.line,
                quantity: 0
              },
              dataType: 'json',
              complete: function () {
                Shopify.theme.jsAjaxCart.updateView();
              }
            });
            if (done) done(false);
          } else {
            if (done) done(true);
          }
          return;
        }

        if (feeLine) {
          if (feeLine.quantity !== rentalQty) {
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                line: feeLine.line,
                quantity: rentalQty
              },
              dataType: 'json',
              complete: function () {
                Shopify.theme.jsAjaxCart.updateView();
              }
            });
            if (done) done(false);
          } else {
            if (done) done(true);
          }
        } else {
          $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify({
              items: [{
                id: Number(feeVariantId),
                quantity: rentalQty,
                properties: {
                  _trunk_fee: 'true'
                }
              }]
            }),
            complete: function () {
              Shopify.theme.jsAjaxCart.updateView();
            }
          });
          if (done) done(false);
        }
      }).fail(function() {
        if (done) done(false);
      });
    },


    unload: function () {
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }
})();
